<!-- 选择类型 -->
<template>
  <div id="choose">
    <div class="choose">
      <img :src="logo"
           alt="再来人Logo">
      <p class="choose-title">Choose mentor type</p>
      <ul class="choose-list"
          v-if='mentorList.length > 0'>
        <li v-for="(item,index) in mentorList"
            :key="index"
            @click="selMentorHandle(item)">
          <h1>{{ item.role && mentorTypeTitle(item.role) }}</h1>
          <h3>{{item.productLine ? new Map(productLineMap).get(item.productLine) : ''}}</h3>
          <div class="choose-num">
            <strong>{{item.menteeNums || 0}}</strong>
            <div>Mentees</div>
          </div>
          <p>{{item.activites || 0}} Activities</p>
          <div class="choose-messages">
            {{item.msgNum || 0}} Unread messages
          </div>
        </li>
      </ul>
    </div>
    <choose-prompt ref="prompt"></choose-prompt>
    <Bottom></Bottom>
    <zlr-modal v-model="confirmModal" width="1000px" :maskClosable="false">
    <div class="confirm-contract-desc">
      <div class="confirm-contract-header">Please confirm updated terms and conditions(请确认以下合同内容)</div>
      <div class="iframe-wrap">
        <iframe :src="confirmContractUrl" frameborder="0" width="900" height="500"></iframe>
      </div>
      <div class="confirm-contract-accept">
        <Checkbox v-model="formValidate.isConfirm">I've read and accept the terms &amp; conditions above</Checkbox>
      </div>
      <div class="confirm-contract-date">{{nowDate}}</div>
      <div class="confirm-contract-btn">
        <Button class="zlr-btn-primary" @click="confirmResign">Confirm</Button>&nbsp;
        <Button class="zlr-btn-default" @click="closeRemindModal">Cancel</Button>
      </div>
    </div>
  </zlr-modal>

    <zlr-modal v-model="confirmApplyMattersModal" width="1000px" :maskClosable="false">
      <div class="confirm-contract-desc">
        <div class="confirm-contract-header">Please carefully read 10 Key Things to Note for SMCM before application season</div>
        <div class="iframe-wrap">
          <iframe src="https://zlrvaleon-om.oss-cn-beijing.aliyuncs.com/msp/docs/mentor/apply_matters.pdf" frameborder="0" width="900" height="500"></iframe>
        </div>
        <div class="confirm-contract-accept">
          <Checkbox v-model="formApplyMattersValidate.isConfirm">I've read and understand the 10 Key Things to Note for SMCM above</Checkbox>
        </div>
        <div class="confirm-contract-btn">
          <Button class="zlr-btn-primary" @click="applyMattersConfirm">Confirm</Button>&nbsp;
        </div>
      </div>
    </zlr-modal>
    <!-- 弹窗capacity -->
     <zlr-modal v-model="capacityModal" width="1000px" :maskClosable="false">
       <div class="confirm-contract-desc capacity-modal">
          <div class="confirm-contract-header">School Mentor Capacity Check - Future Application Season </div>
          <div class="samll-title">How many mentees would you like to take on ?</div>
          <div class="notes">
            <p>Notes: 2022 means the mentee is applying for 2022 fall enrollment, therefore you will help the mentees mostly in 2021 Fall.</p>
            <p>Your updated capacity must be greater or equals to your current carrying mentee number.  </p>
          </div>
          <Form ref="formValidateCapacity"
                :model="formValidateCapacity"
                :rules="ruleValidateCapacity">
                <Row :gutter="50">
                  <Col span="12">
                    <FormItem label="2022 (application season of this year)"
                              prop="count22"
                              class="dis-30">
                        <Select v-model="formValidateCapacity.count22">
                            <Option :value="index" v-for="(item,index) in 11" :key="index">{{index}}</Option>
                        </Select>
                    </FormItem>
                  </Col>
                  <Col span="6">
                      <FormItem label="2023"
                                prop="count23"
                                class="dis-30">
                          <Select v-model="formValidateCapacity.count23">
                              <Option :value="index" v-for="(item,index) in 11" :key="index">{{index}}</Option>
                          </Select>
                      </FormItem>
                  </Col>
                  <Col span="6">
                      <FormItem label="2024"
                                prop="count24"
                                class="dis-30">
                          <Select v-model="formValidateCapacity.count24">
                              <Option :value="index" v-for="(item,index) in 11" :key="index">{{index}}</Option>
                          </Select>
                      </FormItem>
                  </Col>
                </Row>
          </Form>
          <div class="confirm-contract-btn">
            <Button class="zlr-btn-primary" @click="capacityConfirm('formValidateCapacity')">Confirm</Button>&nbsp;
          </div>
          <div class="tips" v-if="isErrorShow">
            <Icon type="ios-alert-outline" class="icon-alert" /><span>Your updated capacity must be greater or equals to your current carrying mentee number.</span>
          </div>
       </div>
     </zlr-modal>
  </div>
</template>

<script>
// api
import { getMentorRole, putMentorRole, getConractInfo, confirmContractResign, contractRemind, getApplyMattersConfirmStatus, applyMattersConfirm, jointCountInyear, capacityTalents, capacityTalentsModal, capacityBackForm } from '@/api/talents'
import { ossSecretLink } from '@/api/oss'
// less
import './index.less'
// images
import logo from '@/assets/Logo.svg'
// components
import Bottom from './intro-bottom'
import ChoosePrompt from './components/choose-type-prompt'
import { mentorTypeTitle } from '@/libs/filters'
import { productLineMap } from './contants'
import ZlrModal from '_c/modal/modal'

// mixins
import bgColor from '@/view/mixins/bg-color-white'

import dayjs from 'dayjs'

export default {
  name: 'choose-type',
  mixins: [bgColor],
  components: {
    Bottom,
    ChoosePrompt,
    ZlrModal
  },
  data () {
    const validateCount22 = (rule, value, callback) => {
      if (value < this.startCount22) {
        callback(new Error('Your updated capacity must be greater or equals to your current carrying mentee number.'))
      } else {
        callback()
      }
    }
    const validateCount23 = (rule, value, callback) => {
      if (value < this.startCount23) {
        callback(new Error('Your updated capacity must be greater or equals to your current carrying mentee number.'))
      } else {
        callback()
      }
    }
    const validateCount24 = (rule, value, callback) => {
      if (value < this.startCount24) {
        callback(new Error('Your updated capacity must be greater or equals to your current carrying mentee number.'))
      } else {
        callback()
      }
    }
    return {
      logo,
      // 是本科还是硕博映射
      productLineMap,
      mentorTypeTitle,
      mentorList: [],
      // 确认合同弹窗标识
      confirmModal: false,
      confirmApplyMattersModal: false,
      formValidate: {
        isConfirm: false
      },
      formApplyMattersValidate: {
        isConfirm: false
      },
      nowDate: '',
      confirmContractUrl: '',
      // 修改capacity
      capacityModal: false,
      formValidateCapacity: {
        count22: '',
        count23: '',
        count24: ''
      },
      ruleValidateCapacity: {
        count22: [
          { required: true, message: 'The year cannot be empty' },
          { validator: validateCount22, trigger: 'change' }
        ],
        count23: [
          { required: true, message: 'The year cannot be empty' },
          { validator: validateCount23, trigger: 'change' }
        ],
        count24: [
          { required: true, message: 'The year cannot be empty' },
          { validator: validateCount24, trigger: 'change' }
        ]
      },
      startCount22: '',
      startCount23: '',
      startCount24: '',
      isErrorShow: false
    }
  },
  computed: {},
  created () {
    this.jointCountInyear()
    this.capacityBackForm()
  },
  mounted () {
    // 获取导师合同信息
    this.getContractDetail()
    this.getapplymattersconfirmstatus()
    this.getMentorRole()
    // 获取是否弹窗capacity
    this.showCapacityModal()
  },
  methods: {
    getMentorRole () {
      getMentorRole().then(res => {
        this.mentorList = res.data.mentorList
        if (res.data.flag) {
          this.$refs['prompt'].show()
        }
      })
    },
    // 选择导师
    selMentorHandle (item) {
      putMentorRole({
        mentorRole: item.role,
        mentorId: item.mentorId
      }).then(res => {
        // payment路由跳转逻辑
        if (['UGDCM', 'UGDEM', 'UGDFAO'].includes(item.role)) {
          this.$router.push({
            name: 'home-index'
          })
        }
        if (['SM', 'CM', 'EM'].includes(item.role)) {
          if (localStorage.getItem('paymentRoute')) {
            localStorage.removeItem('paymentRoute')
            this.$router.push({
              name: 'personal-payment'
            })
          } else {
            this.$router.push({
              name: 'home-index'
            })
          }
        }
      })
    },
    // 获取导师合同信息
    getContractDetail () {
      return getConractInfo().then(res => {
        // 如果没有合同信息，就不展示弹窗
        if (res.data.contractInfo && res.data.contractInfo.contractUrl) {
          ossSecretLink({
            dir: res.data.contractInfo.contractUrl
          }).then(res => {
            // 打开弹窗
            this.nowDate = dayjs().format('YYYY-MM-DD')
            this.confirmContractUrl = res.data.url
            this.confirmModal = true
          })
        }
      }).catch(error => {
        this.$zlr_message(error.message, 'error')
      })
    },
    getapplymattersconfirmstatus () {
      return getApplyMattersConfirmStatus().then(res => {
        if (!res.data.model) {
          this.confirmApplyMattersModal = true
        }
      }).catch(error => {
        this.$zlr_message(error.message, 'error')
      })
    },
    applyMattersConfirm () {
      if (!this.formApplyMattersValidate.isConfirm) {
        this.$zlr_message('Please confirm you read and understand the 10 Key Things to Note for SMCM', 'error')
        return
      }
      applyMattersConfirm().then(res => {
        this.confirmApplyMattersModal = false
      }).catch(error => {
        this.$zlr_message(error.message, 'error')
        this.confirmApplyMattersModal = false
      })
    },
    // 确认重新签约
    confirmResign () {
      if (!this.formValidate.isConfirm) {
        this.$zlr_message('Please confirm updated terms and conditions', 'error')
        return
      }
      confirmContractResign().then(res => {
        this.confirmModal = false
      }).catch(error => {
        this.$zlr_message(error.message, 'error')
        this.confirmModal = false
      })
    },
    // 关闭弹窗后提醒
    closeRemindModal () {
      contractRemind().then(res => {
        this.confirmModal = false
      }).catch(error => {
        this.confirmModal = false
        this.$zlr_message(error.message, 'error')
      })
    },
    // 获取是否弹窗capacity
    showCapacityModal () {
      capacityTalentsModal().then(res => {
        if (res.code === 0) {
          this.capacityModal = res.data.model
          // this.capacityModal = true
        }
      })
    },
    jointCountInyear () {
      jointCountInyear().then(res => {
        if (res.code === 0) {
          let yearCount = res.data ? res.data : {}
          Object.keys(yearCount).forEach((index) => {
            if (index === '2022') {
              this.startCount22 = yearCount[index]
            }
            if (index === '2023') {
              this.startCount23 = yearCount[index]
            }
            if (index === '2024') {
              this.startCount24 = yearCount[index]
            }
          })
        }
      })
    },
    capacityConfirm (name) {
      this.$refs[name].validate((valid) => {
        if (valid) {
          this.isErrorShow = false
          let capacity = []
          capacity.push({ year: 2022, count: this.formValidateCapacity.count22 }, { year: 2023, count: this.formValidateCapacity.count23 }, { year: 2024, count: this.formValidateCapacity.count24 })
          capacityTalents({ capacity: capacity }).then(res => {
            if (res.code === 0) {
              this.capacityModal = false
            }
          })
        } else {
          this.isErrorShow = true
          this.$zlr_message('Your updated capacity must be greater or equals to your current carrying mentee number.', 'error')
        }
      })
    },
    capacityBackForm () {
      capacityBackForm().then(res => {
        if (res.code === 0) {
          let yearCount = res.data ? res.data : {}
          Object.keys(yearCount).forEach((index) => {
            if (index === '2022') {
              this.formValidateCapacity.count22 = yearCount[index]
            }
            if (index === '2023') {
              this.formValidateCapacity.count23 = yearCount[index]
            }
            if (index === '2024') {
              this.formValidateCapacity.count24 = yearCount[index]
            }
          })
        }
      })
    }
  }
}
</script>
<style lang='less' scoped>
.confirm-contract-desc {
  .confirm-contract-header {
    font-size: 18px;
  }
  .iframe-wrap {
    height: 540px;
    margin: 0 auto;
    padding: 20px 0;
  }
  .confirm-contract-accept {
    .ivu-checkbox-wrapper {
      font-size: 14px;
      color: #666;
    }
  }
  .confirm-contract-date {
    text-align: center;
    padding: 10px 0;
  }
  .confirm-contract-btn {
    text-align: center;
  }
}
.capacity-modal{
  padding:20px 0;
 .confirm-contract-header{
   text-align: center;
   padding-bottom:60px;
 }
 .samll-title{
   font-size:16px;
 }
 .notes{
   color:#666;
   font-size:14px;
   padding:30px 0;
 }
 .confirm-contract-btn{
   margin-top:40px;
 }
 .tips{
   display: flex;
   justify-content: center;
   align-items: center;
   color:#F10505;
   font-size:12px;
   padding-top:30px;
   .icon-alert{
    font-size:18px;
    color:#F10505;
    margin-right:10px;
   }
 }
}
</style>
